/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Passkey`)
};

const zh_hans1_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加通行密钥`)
};

const zh_hant1_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增通行金鑰`)
};

const fr_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une passkey`)
};

const de_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey hinzufügen`)
};

const ja_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを追加`)
};

const ko_settings_add_passkey = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키 추가`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_add_passkey = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_add_passkey(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_add_passkey", locale)
	if (locale === "en") return en_settings_add_passkey(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_add_passkey(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_add_passkey(inputs)
	if (locale === "fr") return fr_settings_add_passkey(inputs)
	if (locale === "de") return de_settings_add_passkey(inputs)
	if (locale === "ja") return ja_settings_add_passkey(inputs)
	return ko_settings_add_passkey(inputs)
};